<div>
  <i nz-icon nzType="money-collect" nzTheme="twotone" class="header-icon"></i
  >&nbsp;<b class="header-label">Fines</b>
</div>
<!-- </div>
</div> -->
@if (usrAcsErrMsg == false) {
<div>
  <div class="ds-card grid">
    @if (shwLdg) {
    <ds-loading></ds-loading>
    }
    <app-data-grid
      id="gridContainer"
      style="width: 100%"
      [dataSource]="finesLst"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
      exportFileName="LMO Details"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="USER_PERMISSIONS.updt_in == 1 ? true : false"
        type="buttons"
        [width]="100"
        caption="Edit"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div
            class="cursor-pointer tblEdtBtn"
            (click)="onCellClick('edit', data)"
          >
            Edit
          </div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
        type="buttons"
        [width]="100"
        caption="Delete"
        cellTemplate="delTemplate"
      ></app-grid-column>
      <ng-template appGridCell="delTemplate" let-data="cell"
        ><div>
          <div
            class="cursor-pointer tblDelBtn"
            (click)="onCellClick('delete', data)"
          >
            Delete
          </div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="350"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="mb-20">
      <div class="inptLbl">Fine Category</div>
      <input
        placeholder="Select Fine Category"
        nz-input
        [(ngModel)]="fneCtgry"
        (ngModelChange)="onChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete #auto>
        @for (c of filteredOptions; track c) {
        <nz-auto-option [nzValue]="c.ctgry_nm">{{ c.ctgry_nm }}</nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <!-- <div class="mb-20">
        <div class="inptLbl">Child Category</div>
        <input placeholder="Select Category" nz-input [(ngModel)]="fneCtgry" (ngModelChange)="onChange($event)" [nzAutocomplete]="auto" />
        <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>
      </div> -->
    <div class="mb-20">
      <div class="inptLbl">Fine Amount</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="fineAmt"
          placeholder="please enter fine amount"
        />
      </nz-input-wrapper>
      <ng-template #inputClearTpl
        >@if (fineAmt) {
        <i
          nz-icon
          class="ant-input-clear-icon"
          nzTheme="fill"
          nzType="close-circle"
          (click)="fineAmt = null"
        ></i>
        }</ng-template
      >
    </div>
    @if (shwDprtEditDiv==false && shwDprtDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveFines()">
      Submit
    </button>
    } @if (shwDprtEditDiv==true && shwDprtDelDiv==false) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      (click)="saveEditFines()"
    >
      Update
    </button>
    } @if (shwDprtEditDiv==false && shwDprtDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this fine?"
      nzPopconfirmPlacement="bottom"
      [nzPopconfirmShowArrow]="false"
      nzOkType="danger"
      nzOkText="YES"
      nzCancelText="NO"
      [nzIcon]="iconTpl"
      (nzOnConfirm)="saveDeleteFines()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    }
    <ng-template #iconTpl>
      <i nz-icon nzType="question-circle-o" style="color: red"></i>
    </ng-template>
  </nz-drawer>
  <!-- </div>
</div>
</div> -->
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
